import type { hotComments, stats } from '@/mocks/home';

interface HotCommentsProps {
  comments: typeof hotComments;
  statsData: typeof stats;
}

export default function HotComments({ comments, statsData }: HotCommentsProps) {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-[55%]">
            <div className="flex items-center gap-3 mb-8">
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className="ri-chat-3-line"></i>
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950">
                吃瓜热评
              </h2>
            </div>

            <div className="flex flex-col gap-5">
              {comments.map((comment, idx) => (
                <div
                  key={comment.id}
                  className={`rounded-2xl p-5 md:p-6 transition-all duration-300 ${
                    idx === 0
                      ? 'bg-foreground-950 text-background-50'
                      : 'bg-background-100 hover:bg-background-200/70'
                  }`}
                >
                  {idx === 0 && (
                    <div className="text-primary-400 text-5xl font-serif leading-none mb-2 opacity-60">
                      &ldquo;
                    </div>
                  )}
                  <p className={`text-sm md:text-base leading-relaxed ${idx === 0 ? 'text-background-50/90' : 'text-foreground-700'}`}>
                    {comment.content}
                  </p>
                  <div className="flex items-center gap-3 mt-4">
                    <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0">
                      <img src={comment.avatar} alt={comment.user} className="w-full h-full object-cover" loading="lazy" />
                    </div>
                    <div className="flex-1">
                      <span className={`text-sm font-medium ${idx === 0 ? 'text-background-50' : 'text-foreground-800'}`}>
                        {comment.user}
                      </span>
                      <span className={`text-xs ml-2 ${idx === 0 ? 'text-background-50/40' : 'text-foreground-400'}`}>
                        {comment.floor} · {comment.time}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:w-[45%]">
            <div className="flex items-center gap-3 mb-8">
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className="ri-bar-chart-2-line"></i>
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950">
                平台数据
              </h2>
            </div>

            <div className="bg-foreground-950 rounded-2xl p-6 md:p-8 h-full">
              <div className="grid grid-cols-2 gap-4 md:gap-6">
                {statsData.map((stat) => (
                  <div key={stat.label} className="text-center p-4 rounded-xl bg-background-50/5">
                    <div className="text-2xl md:text-3xl font-heading font-black text-primary-400">
                      {stat.value}
                    </div>
                    <div className="mt-1 text-xs text-background-50/40">{stat.label}</div>
                  </div>
                ))}
              </div>
              <div className="mt-8 pt-6 border-t border-background-50/10">
                <p className="text-background-50/50 text-sm leading-relaxed text-center">
                  我们不做谣言的制造者，只做真相的搬运工。
                  <br />
                  所有内容均来自网友投稿和公开信息整理。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}